'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _presentation = require('../../actions/presentation');

var _pickupLocations = require('../../actions/pickupLocations');

var mapStateToProps = function mapStateToProps(state) {
  return {
    pickupLocations: state.pickupLocator.locations,
    fetchingPickupLocations: state.pickupLocator.fetching,
    initialTerm: state.pickupLocator.initialTerm,
    confirmed: state.pickupLocator.confirmed,
    gps: state.pickupLocator.gps,
    canUseGps: state.pickupLocator.gpsAvailable,
    addressDetails: state.addressForm.addressDetails,
    onOpen: state.pickupLocator.onOpen
  };
};

var mapDispatchToProps = {
  search: _pickupLocations.fetchPickupLocationsByTerm,
  open: _presentation.showPickupLocator,
  close: _presentation.hidePickupLocator,
  selectLocation: _pickupLocations.selectPickupLocation,
  confirm: _pickupLocations.confirmPickupLocation,
  gpsUnavailable: _pickupLocations.gpsUnavailable
};

exports.default = function (baseComponent) {
  return (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(baseComponent);
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/higherOrder/pickupLocations/fluxWrapper.js
// module id = 560
// module chunks = 0